import React, { useState, useEffect, useRef, useContext } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { isAdminProfile } from "../../utils/isAdminProfile";
import { parseISO, format, isSameDay } from "date-fns";
import emojiRegex from "emoji-regex";
import { v4 as uuidv4 } from "uuid";

import { styled } from "@mui/material/styles";
import { green } from "@mui/material/colors";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import { i18n } from "../../translate/i18n";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckIcon from "@mui/icons-material/CheckCircle";
import ReplayIcon from "@mui/icons-material/Replay";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import api from "../../services/api";
import { Dialog, DialogContent } from "@mui/material";

import MarkdownWrapper from "../MarkdownWrapper";
import { Tooltip } from "@mui/material";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";

import facebookIcon from "../../assets/facebook.png";
import insatagramIcon from "../../assets/instagram.png";
import whatsappIcon from "../../assets/whatsapp.png";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 22,
    height: 22,
    border: `2px solid ${theme.palette.background.paper}`,
}));

const getAvatarChannel = (channel) => {
    if (channel === "facebook") {
        return facebookIcon;
    }

    if (channel === "whatsapp") {
        return whatsappIcon;
    }

    if (channel === "whatsappapi") {
        return whatsappIcon;
    }

    if (channel === "instagram") {
        return insatagramIcon;
    }
};

const TicketListItem = ({ ticket }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { ticketId } = useParams();
    const isMounted = useRef(true);
    const { user } = useContext(AuthContext);
    const { setCurrentTicket, setTabOpen } = useContext(TicketsContext);
    const [imageModalOpen, setImageModalOpen] = useState(false);

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    const handleImageClick = (e) => {
        e.stopPropagation();
        if (ticket?.contact?.urlPicture) {
            setImageModalOpen(true);
        }
    };

    const handleImageModalClose = () => {
        setImageModalOpen(false);
    };

    function getRatingIcon(rate) {
        let icon = "";
        if (rate === 1) {
            icon = "😡";
        } else if (rate === 2) {
            icon = "😠";
        } else if (rate === 3) {
            icon = "😐";
        } else if (rate === 4) {
            icon = "😃";
        } else if (rate === 5) {
            icon = "😍";
        }

        return icon;
    }


    const handleAcepptTicket = async (ticket) => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "open",
                userId: user?.id,
            });
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
        if (isMounted.current) {
            setLoading(false);
        }
        navigate(`/tickets/${ticket.uuid}`);
    };

    const handleAcepptTicketBot = async (ticket) => {
        // alert("Bot");
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "open",
                userId: user?.id,
            });
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
        if (isMounted.current) {
            setLoading(false);
        }
        navigate(`/tickets/${ticket.uuid}`);
    };

    const handleReopenTicket = async (ticket) => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "open",
                userId: user?.id,
            });
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
        if (isMounted.current) {
            setLoading(false);
        }
        navigate(`/tickets/${ticket.uuid}`);
    };

    const handleViewTicket = async (ticket) => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "pending",
            });
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
        if (isMounted.current) {
            setLoading(false);
        }
        navigate(`/tickets/${ticket.uuid}`);
    };

    const handleSelectTicket = (ticket) => {
        const code = uuidv4();
        const { id, uuid } = ticket;
        setTabOpen(ticket.status)
        setCurrentTicket({ id, uuid, code });
    };

    const handleClosedTicket = async (ticket) => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "closed",
            });
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
        if (isMounted.current) {
            setLoading(false);
        }
    };

    const renderUserName = (name) => {
        let str = name.replace(emojiRegex(), "").trim();

        const firstName = str.split(" ")[0];

        return firstName;
    };

    return (
        <React.Fragment key={ticket.id}>
            <ListItem
                dense
                button
                onClick={(e) => {
                    handleSelectTicket(ticket)
                }}
                selected={ticketId && +ticketId === ticket.id}
                sx={{
                    position: "relative",
                    ...(ticket.status === "pending" && { cursor: "unset" }),
                }}
            >
                <Tooltip
                    arrow
                    placement="right"
                    title={ticket.queue?.name || "Sem departamento"}
                >
                    <Box
                        component="span"
                        style={{ backgroundColor: ticket.queue?.color || "#7C7C7C" }}
                        sx={{
                            flex: "none",
                            width: "8px",
                            height: "100%",
                            position: "absolute",
                            top: "0%",
                            left: "0%",
                        }}
                    />
                </Tooltip>
                <ListItemAvatar>
                    <Badge
                        overlap="circular"
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        badgeContent={
                            <SmallAvatar
                                alt={ticket?.channel}
                                src={getAvatarChannel(ticket?.channel)}
                            />
                        }
                    >
                        <Avatar
                            alt={ticket?.contact?.name}
                            src={ticket?.contact?.urlPicture}
                            sx={{ cursor: "pointer", "&:hover": { opacity: 0.8 } }}
                            onClick={handleImageClick}
                        />
                    </Badge>
                </ListItemAvatar>
                <ListItemText
                    disableTypography
                    primary={
                        <Box component="span" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "6px" }}>
                            <Typography
                                noWrap
                                component="span"
                                variant="body2"
                                color="textPrimary"
                                sx={{ flex: 1, minWidth: 0 }}
                            >
                                {ticket.contact.name}
                            </Typography>

                            {ticket.whatsappId && (
                                <Box
                                    component="span"
                                    title={i18n.t("ticketsList.connectionTitle")}
                                    sx={theme => ({
                                        flexShrink: 0,
                                        bgcolor: theme.palette.mode === "dark" ? "rgba(3,153,255,0.12)" : "rgba(3,153,255,0.08)",
                                        color: "primary.main",
                                        border: `1px solid ${theme.palette.mode === "dark" ? "rgba(3,153,255,0.3)" : "rgba(3,153,255,0.2)"}`,
                                        p: "1px 6px",
                                        borderRadius: "10px",
                                        fontSize: "0.75em",
                                    })}
                                >
                                    {ticket.whatsapp?.name}
                                </Box>
                            )}

                            <Typography
                                component="span"
                                variant="body2"
                                color="textSecondary"
                                sx={{ flexShrink: 0 }}
                            >
                                {isSameDay(
                                    parseISO(ticket.updatedAt),
                                    new Date()
                                ) ? (
                                    <>
                                        {format(
                                            parseISO(ticket.updatedAt),
                                            "HH:mm"
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {format(
                                            parseISO(ticket.updatedAt),
                                            "dd/MM/yyyy"
                                        )}
                                    </>
                                )}
                            </Typography>
                        </Box>
                    }
                    secondary={
                        <Box component="span" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "6px" }}>
                            {ticket.status === "closed"
                                ? ticket?.userRating
                                    ? getRatingIcon(ticket?.userRating?.rate)
                                    : null
                                : null}
                            <Typography
                                noWrap
                                component="span"
                                variant="body2"
                                color="textSecondary"
                                sx={{ flex: 1, minWidth: 0 }}
                            >
                                {ticket.lastMessage ? (
                                    <MarkdownWrapper>
                                        {ticket.lastMessage}
                                    </MarkdownWrapper>
                                ) : (
                                    <br />
                                )}
                            </Typography>

                            <Badge
                                overlap="rectangular"
                                sx={{
                                    flexShrink: 0,
                                    "& .MuiBadge-badge": {
                                        position: "static",
                                        transform: "none",
                                        color: "white",
                                        backgroundColor: green[500],
                                    },
                                }}
                                badgeContent={ticket.unreadMessages}
                            />
                        </Box>
                    }
                />
                {ticket.status === "pending" && (
                    <IconButton
                        sx={{ top: "12px" }}
                        color="primary"
                        loading={loading.toString()}
                        onClick={(e) =>
                            ticket.isBot
                                ? handleAcepptTicketBot(ticket)
                                : handleAcepptTicket(ticket)
                        }
                    >
                        <CheckIcon />
                    </IconButton>
                )}
                {/* {ticket.status === "pending" && (
                    <IconButton
                        sx={{ top: "12px" }}
                        color="primary"
                        onClick={(e) => handleViewTicket(ticket)}
                    >
                        <VisibilityIcon />
                    </IconButton>
                )} */}
                <Box
                    sx={{
                        position: "absolute",
                        left: 0,
                        bottom: 0,
                        flexWrap: "wrap",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}
                >
                    {ticket.user?.id &&
                        isAdminProfile(user.profile) && (
                            <Box sx={{ zIndex: 500 }}>
                                <Box
                                    key={ticket.user.id}
                                    title={renderUserName(ticket.user.name)}
                                    sx={{
                                        color: "#FFF",
                                        border: "1px solid #CCC",
                                        p: 0,
                                        pl: "5px",
                                        pr: "5px",
                                        borderRadius: "0px",
                                        fontSize: "0.6em",
                                        textAlign: "center",
                                        backgroundColor:
                                            ticket.user.color === "" || !ticket.user.color
                                                ? "#7C7C7C"
                                                : ticket.user.color,
                                    }}
                                >
                                    {renderUserName(ticket.user.name)}
                                </Box>
                            </Box>
                        )}
                    {ticket.tags?.length > 0 && (
                        <>
                            <Box sx={{ zIndex: 500 }}>
                                <Box
                                    key={ticket.tags[0].id}
                                    title={ticket.tags[0].name}
                                    sx={{
                                        color: "#FFF",
                                        border: "1px solid #CCC",
                                        p: 0,
                                        pl: "5px",
                                        pr: "5px",
                                        borderRadius: "0px",
                                        fontSize: "0.6em",
                                        textAlign: "center",
                                        backgroundColor: ticket.tags[0].color,
                                    }}
                                >
                                    {ticket.tags[0].name}
                                </Box>
                            </Box>
                            {ticket.tags.length > 1 && (
                                <Box
                                    key={ticket.tags[1].id}
                                    title={ticket.tags[1].name}
                                    sx={{
                                        color: "#FFF",
                                        border: "1px solid #CCC",
                                        p: 0,
                                        pl: "5px",
                                        pr: "5px",
                                        borderRadius: "0px",
                                        fontSize: "0.6em",
                                        textAlign: "center",
                                        backgroundColor: ticket.tags[1].color,
                                    }}
                                >
                                    +{ticket.tags.length - 1}
                                </Box>
                            )}
                        </>
                    )}
                    {/* {ticket?.contact?.contactWallets && ticket.contact.contactWallets.length > 0 && (
                        <Box sx={{ zIndex: 500 }}>
                            <Box
                                title={`Carteira: ${ticket.contact.contactWallets[0].wallet?.name || 'N/A'}`}
                                sx={{
                                    color: "#FFF",
                                    border: "1px solid #CCC",
                                    p: 0,
                                    pl: "5px",
                                    pr: "5px",
                                    borderRadius: "0px",
                                    fontSize: "0.6em",
                                    textAlign: "center",
                                    backgroundColor: "#FF6B35",
                                }}
                            >
                                📋 {ticket.contact.contactWallets[0].wallet?.name || 'N/A'}
                            </Box>
                        </Box>
                    )} */}
                </Box>

                {(ticket.status === "pending" && (user.showDashboard === "enabled" || isAdminProfile(user.profile))) && (
                    <IconButton
                        sx={{ top: "12px" }}
                        color="primary"
                        onClick={(e) => handleClosedTicket(ticket)}
                    >
                        <ClearOutlinedIcon />
                    </IconButton>
                )}
                {ticket.status === "open" && (
                    <IconButton
                        sx={{ top: "12px" }}
                        color="primary"
                        onClick={(e) => handleViewTicket(ticket)}
                    >
                        <ReplayIcon />
                    </IconButton>
                )}
                {ticket.status === "open" && (
                    <IconButton
                        sx={{ top: "12px" }}
                        color="primary"
                        onClick={(e) => handleClosedTicket(ticket)}
                    >
                        <ClearOutlinedIcon />
                    </IconButton>
                )}
                {ticket.status === "closed" && (
                    <IconButton
                        sx={{ top: "12px" }}
                        color="primary"
                        onClick={(e) => handleReopenTicket(ticket)}
                    >
                        <ReplayIcon />
                    </IconButton>
                )}
                {ticket.status === "closed" && (
                    <IconButton
                        sx={{ top: "12px" }}
                        color="primary"
                    ></IconButton>
                )}
            </ListItem>
            <Divider variant="inset" component="li" />

            {/* Modal da Imagem */}
            <Dialog
                open={imageModalOpen}
                onClose={handleImageModalClose}
                sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                maxWidth="md"
                fullWidth
            >
                <DialogContent sx={{ outline: "none", maxWidth: "90vw", maxHeight: "90vh" }}>
                    <Box
                        component="img"
                        src={ticket?.contact?.urlPicture}
                        alt={ticket?.contact?.name || "Foto do contato"}
                        sx={{ width: "100%", height: "auto", maxWidth: "500px", borderRadius: "1px" }}
                    />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default TicketListItem;
